import React from "react";
import { bootcamp_benefits, bootcamp_levels } from "@/constants";
import { SectionContainerLight } from "../common/sections/SectionContainerLight";

const HeroSection = () => {
  return (
    <SectionContainerLight id='bootcamp_hero' additionalClassName="mx-6 !py-0 my-8">
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <img
        src="/img/course/ornaments/book.png"
        alt="book"
        className="absolute hidden lg:block top-[250px] left-[400px] w-[100px]"
        />
        <img
          src="/img/course/ornaments/cross.png"
          alt="cross"
          className="absolute hidden lg:block top-[120px] right-[80px] w-[100px]"
        />
        <img
          src="/img/course/ornaments/dots.png"
          alt="dots"
          className="absolute hidden lg:block top-[30px] left-[670px] w-[100px]"
        />
        <img
          src="/img/course/ornaments/triangle.png"
          alt="triangle"
          className="absolute hidden lg:block bottom-10 right-[450px] w-[50px]"
        />
        <div className="hidden lg:block absolute -top-15  -right-1 -z-6 h-[70%] w-[620px] pointer-events-none">
          <img
            src="/img/course/bootcamp/hero-person-bootcamp2.png"
            alt="Hero Person"
            className="h-full w-full object-contain"
          />
        </div>

        <div className="flex flex-col lg:flex-row lg:items-start gap-10">
          <div className="w-full lg:w-1/2 lg:pr-12 lg:ml-10 mb-4 mt-4">
            <p className="text-teal-600 text-xl sm:text-2xl font-medium mb-2">Bootcamp</p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight ">
              From Zero to Hero: <br/>A Beginner&apos;s Guide
            </h1>
            <p className="text-gray-700 font-semibold text-base sm:text-lg mb-6">
              Saatnya Kuasai Skill Baru, Mulai dari Nol hingga Siap Kerja, dan Wujudkan Karier Impianmu!
            </p>

            <p className="text-gray-800 font-semibold text-sm sm:text-base mb-2 -mt-2">
              Benefit yang didapatkan
            </p>
            <ul className="md:space-y-2 text-gray-800 text-sm sm:text-base mb-6">
              {bootcamp_benefits.map((text, index) => (
                <li key={index} className="flex items-center gap-3">
                  <span className="text-green-600 text-lg">✅</span>
                  <span className="font-semibold leading-tight">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="-mt-4 md:-mt-8 -mb-6">
          <div className="grid grid-cols-2 gap-4 sm:hidden border-2 border-black rounded-xl p-3 bg-white">
            {bootcamp_levels.map((item, index) => (
              <div key={index} className="text-center flex flex-col items-center">
                <img src={item.icon} alt={item.text} className="mb-1 w-6 h-6" />
                <p className="text-base font-bold text-blue-800">{item.number}</p>
                <p className="text-xs text-gray-600 whitespace-pre-line mt-1">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="hidden sm:block mt-6">
            <div className="max-w-fit border-2 border-black rounded-xl p-4 ml-10 mt-4 bg-white">
              <div className="flex flex-col md:flex-row md:items-start items-center">
                {bootcamp_levels.map((phase, index) => (
                  <div key={index} className="flex flex-col items-center md:flex-row md:items-start">
                    <div className="flex flex-col items-center md:items-start">
                      <img src={phase.icon} alt={phase.text} width={48} height={48} />
                      <p className="font-bold text-blue-600 text-base md:text-sm mt-2">{phase.number}</p>
                      <p className="text-gray-800 text-base md:text-xs text-center md:text-justify leading-tight">
                        {phase.text.includes(" ") ? (
                          <>
                            {phase.text.split(" ")[0]} <br />
                            {phase.text.split(" ").slice(1).join(" ")}
                          </>
                        ) : (
                          phase.text
                        )}
                      </p>
                    </div>

                    {phase.subtitle && index < bootcamp_levels.length - 1 && (
                      <div className="-translate-y-2 flex flex-col items-center justify-center ml-2 mr-1 mt-3">
                        <p className="text-xs md:text-[10px] font-bold text-gray-600 text-center leading-tight mb-1">
                          {phase.subtitle.split(" ").map((word, i) => (
                            <span key={i}>
                              {word}
                              <br />
                            </span>
                          ))}
                        </p>
                        <svg width="100" height="24" viewBox="0 0 100 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="0" y1="4" x2="90" y2="4" stroke="#000" strokeWidth="1.5" strokeDasharray="2 2" />
                          <path d="M90 0 L94 4 L90 8" stroke="#000" strokeWidth="1.0" fill="none" />
                        </svg>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionContainerLight>
  );
};

export default HeroSection;
